import React, { useState, useEffect } from 'react';
import api from '../services/apiService';

function EmployeeTimeLogForm() {
  // Default = heute (YYYY-MM-DD)
  const [selectedDate, setSelectedDate] = useState(() => {
    const heute = new Date();
    const yyyy = heute.getFullYear();
    const mm = String(heute.getMonth() + 1).padStart(2, '0');
    const dd = String(heute.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const [groupedLogs, setGroupedLogs] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      setError('');
      try {
        const params = { date: selectedDate };
        if (selectedEmployee) params.employeeId = selectedEmployee;
        const resp = await api.get('/employeeTimeLogs/dailyPlanningForm', {
          params
        });
        setGroupedLogs(resp.data.groupedEmployees || {});
      } catch (e) {
        console.error('Fehler beim Laden der Daten:', e);
        setError('Daten konnten nicht geladen werden.');
        setGroupedLogs({});
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, [selectedDate, selectedEmployee]);

  useEffect(() => {
    api.get('/employees')
      .then((resp) => {
        const sortedEmployees = [...(resp.data || [])].sort((a, b) => {
          const aName = `${a.lastName || ''} ${a.firstName || ''}`.trim();
          const bName = `${b.lastName || ''} ${b.firstName || ''}`.trim();
          return aName.localeCompare(bName, 'de', { sensitivity: 'base' });
        });
        setEmployees(sortedEmployees);
      })
      .catch(() => setEmployees([]));
  }, []);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleDownloadPDF = () => {
    // PDF herunterladen (wie vorher)
    if (!selectedDate) {
      setError('Bitte ein Datum auswählen!');
      return;
    }
    const baseURL = api.defaults.baseURL;
    const params = new URLSearchParams({ date: selectedDate });
    if (selectedEmployee) params.append('employeeId', selectedEmployee);
    const url = `${baseURL}/employeeTimeLogs/dailyPlanningReport/pdf?${params.toString()}`;
    window.open(url, '_blank');
  };

  return (
    <div style={{ maxWidth: '900px', margin: 'auto', padding: '20px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
        WA-Einsatzliste
      </h2>

      <form
        onSubmit={(e) => e.preventDefault()}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '20px', textAlign: 'center' }}
      >
        <label>
          &nbsp;
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            style={{maxWidth: '150px', padding: '6px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
        </label>
        <select
          value={selectedEmployee}
          onChange={(e) => setSelectedEmployee(e.target.value)}
          style={{ padding: '6px', borderRadius: '4px', border: '1px solid #ccc', maxWidth: '220px' }}
        >
          <option value="">Alle Mitarbeiter</option>
          {employees.map((employee) => (
            <option value={employee.id} key={employee.id}>
              {employee.firstName} {employee.lastName}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={handleDownloadPDF}
          style={{
           
            padding: '6px 12px',
            background: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            
          }}
        >
          PDF herunterladen
        </button>
      </form>

      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      {loading && <p style={{ textAlign: 'center' }}>Lade Daten …</p>}

      {!loading && Object.keys(groupedLogs).length === 0 && (
        <p style={{ textAlign: 'center' }}>
          Für den {new Date(selectedDate).toLocaleDateString('de-DE')} wurden keine Einträge gefunden.
        </p>
      )}

      {!loading && Object.keys(groupedLogs).length > 0 && (
        <div>
          {Object.entries(groupedLogs).map(([employeeName, entries]) => (
            <div key={employeeName} style={{ marginBottom: '30px' }}>
              <h3 style={{ borderBottom: '1px solid #ccc', paddingBottom: '4px' }}>
                {employeeName}
              </h3>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '8px' }}>
                <thead>
                  <tr style={{ background: '#f0f0f0' }}>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>ID</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Auftrags-Nr.</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Item</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Notiz</th>
                    
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Gepl. Start</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Gepl. Ende</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ist: Start</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ist: Ende</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Pause</th>
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Fertig?</th>
                    
                    <th style={{ padding: '8px', border: '1px solid #ddd' }}>Kunde</th>
                    
                    
                  </tr>
                </thead>
                <tbody>
                  {entries.map((log) => (
                    <tr key={log.id}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.id}
                      </td>
                       <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.workshopOrderNr}
                      </td>
                       <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.itemName}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.notes}
                      </td>
                      
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.plannedStart}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.plannedEnd}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.actualStart}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.actualEnd}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.pauseTime}
                      </td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.finished}
                      </td>
                     
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                        {log.customer}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default EmployeeTimeLogForm;
